import React, { useContext, useState, Fragment } from 'react'
import { StatusData, dollars } from '@oneethos/shared'
import { FaHouseChimney, FaBuilding, FaHandHoldingHeart } from 'react-icons/fa6'
import { AppContext } from '../appContext'
import { selectActionRequiredOwners } from '../selectors/checklistItems'
import { ProjectPage } from '../pages'
import { useNavigate } from "react-router-dom"
import './project-list-item.scss'
import { FaExternalLinkSquareAlt } from 'react-icons/fa'

type ProjectListCollapseProps = {
  projects: StatusData[]
}

const projectTypeIcons = {
  'residential': <FaHouseChimney size='15' />,
  'commercial': <FaBuilding size='15' />,
  'non-profit': <FaHandHoldingHeart size='15' />,
}

const formatOwnersWithAnd = (owners?: string[]): string | undefined => {
  if (!owners || owners.length === 0) return undefined

  return owners
    .map(owner => owner.charAt(0).toUpperCase() + owner.slice(1))
    .join(' and ')
}

const ProjectListCollapse = ({ projects }: ProjectListCollapseProps) => {
  const { state } = useContext(AppContext)
  const [showProject, setShowProject] = useState<string | null>(null)
  const navigate = useNavigate()
  const { registration: { installer } } = state
  const isSupport = installer.isSupport

  const handleRowClick = (project: StatusData) => {
    setShowProject(showProject === project.lookup ? null : project.lookup)
  }

  return (
    <div className="table-responsive border rounded-2">
      <table className="table align-middle m-0 table-hover">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Address</th>
            {isSupport && <th>APP ID</th>}
            <th className="text-nowrap">Loan Amount</th>
            <th>Status</th>
            <th className="text-nowrap">Required Action by</th>
            <th style={{ width: '40px' }}></th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => {
            const noActionRequiredStatuses = ['Decisioned - Unable to Proceed/Project Closed', 'Phase 2 Funded']
            const hasNoActionRequired = noActionRequiredStatuses.includes(project.installersStatus)
            const owners = hasNoActionRequired ? [] : selectActionRequiredOwners(state, project)
            const requiredActionOwners = formatOwnersWithAnd(owners)
            const isInstallerActionRequired = owners?.includes('installer')
            const isExpanded = showProject === project.lookup
            const handleNavigation = () => {
              navigate(`/project/${project.lookup}`)
            }

            return (
              <Fragment key={project.id}>
                <tr
                  className={isExpanded ? 'border border-2 border-primary project-row' : 'pointer'}
                  onClick={() => handleRowClick(project)}
                >
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span>{projectTypeIcons[project.projectType]}</span>
                      {project.customerName || project.businessName || 'Referred'}
                    </div>
                    <div className="text-muted">
                      {/* TODO: remove at PR time */}
                      {project.email}
                    </div>
                  </td>
                  <td>
                    {project.address}
                  </td>
                  {isSupport && <td>{project.appId}</td>}
                  <td >
                    {dollars(project.loanAmount)}
                  </td>
                  <td>
                    {project.installersStatus}
                  </td>
                  <td>
                    <span className={isInstallerActionRequired ? 'badge rounded-pill text-bg-warning' : ''}>
                      {requiredActionOwners}
                    </span>
                  </td>
                  <td className="text-center pointer" style={{ width: '40px' }} onClick={handleNavigation}>
                    <FaExternalLinkSquareAlt title="Open Project Page" className='link-hover' size='20' />
                  </td>
                </tr>
                {isExpanded && (
                  <tr className='border border-2 border-primary'>
                    <td colSpan={isSupport ? 7 : 6} className="p-0">
                      <ProjectPage lookup={project.lookup} isExpanded={isExpanded} />
                    </td>
                  </tr>
                )}
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ProjectListCollapse